import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { IMyOptions, IMyDateModel } from 'mydatepicker';

import { PaxFormControlBase } from './index';

@Component({
  selector: 'pax-form-control',
  styles: [require('./pax-form-control.component.sass')],
  template: require('./pax-form-control.component.html')
})
export class PaxFormControlComponent implements OnInit {
  @Input() question: PaxFormControlBase<any>;
  @Input() form: FormGroup;
  mdpOptions: IMyOptions;
  mdpOptionsDefaults: IMyOptions = {
    dateFormat: 'mm/dd/yyyy',
    showDateFormatPlaceholder: true,
    height: '32px'
  };
  isRowFull: boolean;
  isRowInline: boolean;
  mask;
  errorMsg;
  required: boolean = false;
  counter: any;
  disabled: any;

  ngOnInit() {
    this.isRowFull = this.question.layout === 'full';
    this.isRowInline = this.question.layout === 'inline';

    if (this.question.controlType === 'datepicker') {
      let datepickerSettings = this.question['settings'] || {};
      this.mdpOptions = Object.assign({}, this.mdpOptionsDefaults, datepickerSettings);
    }

    this.mask = this.question.mask || null;

    this.required = ((): boolean => {
      let req = false;
      this.question.validation.forEach(rule => req = rule.name === 'required' || req);
      return req;
    })();

    this.disabled = this.question.readonly === true ? true : undefined;
  }

  // dateChanged callback function called when the user select the date. This is mandatory callback
  // in this option. There are also optional inputFieldChanged and calendarViewChanged callbacks.
  onDateChanged(event: IMyDateModel) {
      // event properties are: event.date, event.jsdate, event.formatted and event.epoc
  }

  onKeyup(e) {
    // if length restrictions, show counter
    if (this.question.maxLength) {
      this.counter = parseInt(this.question.maxLength, 10) - e.target.value.length;
    }
  }

  get showError() {
    const errorCondition = this.question.controlType === 'datepicker' ?
      (!this.form.controls[this.question.key].pristine && !this.form.controls[this.question.key].valid) :
      (this.form.controls[this.question.key].touched && !this.form.controls[this.question.key].valid);
    if (errorCondition) {
      this.question.validation.forEach(v => {
        let errorFlag = v.name.toLowerCase();
        let currentErrors = Object.keys(this.form.controls[this.question.key].errors);
        if (currentErrors.includes(errorFlag)) {
          this.errorMsg = v.message;
        }
      });
    }
    return errorCondition;
  }

  get diagnostics() {
    return JSON.stringify(this.question, null, '\t');
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./resources/themes/pandax/bobtail/app/shared/pax-form-control/pax-form-control.component.ts